import { render } from "./DriverProfile.vue?vue&type=template&id=3a5485e6"
import script from "./DriverProfile.vue?vue&type=script&lang=js"
export * from "./DriverProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__